import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box, Typography, Paper } from "@mui/material";

import FloatingMenu from "./components/FloatingMenu";

const UserHomePage = () => {
  const { username } = useParams();
  const [floatMenuLeftMargin, setFloatMenuLeftMargin] = useState(0);
  
  // Set floating menu place based on screen size
  useEffect(() => {
    const handleResize = () => {      
      setFloatMenuLeftMargin(window.innerWidth - 100);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>R3PLAY - {username}'s Page</title>
        <meta
          name="description"
          content={`View ${username}'s profile and toys on R3PLAY`}
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          minHeight: "100vh",
          pt:6,
          px: { xs: 2, md: 4 },
          display: "flex",
          justifyContent: "center",
        }}
      >

          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#333",
              mb: 2,
            }}
          >
            {username}'s Public Page <b>(WIP)</b>
          </Typography>

      </Box>
      <FloatingMenu left={floatMenuLeftMargin} />
    </>
  );
};

export default UserHomePage;
